const PrivacyPolicy = () => {
    return (
        <div role='tabpanel'>
            <h4 id='wp-block-themeisle-blocks-advanced-heading-09292bae'>
                <strong>Política de Privacidade</strong>
            </h4>

            <p>
                <strong>
                    Última revisão: 24 de outubro de 2024Data de vigência: 24 de
                    outubro de 2024
                </strong>
            </p>

            <p></p>

            <p>
                <strong>1. Introdução</strong>
            </p>

            <p>
                A NetDoor Inc. (“nós,” “nosso,” “conosco”) se compromete a
                proteger sua privacidade. Esta Política de Privacidade explica
                como coletamos, usamos, divulgamos e protegemos suas informações
                quando você visita nosso site
                <a href='http://www.plyosgames.com'>
                    {' '}
                    <strong>www.plyosgames.com</strong>
                </a>{' '}
                e seus subdomínios relacionados (coletivamente, o “Site”). Leia
                esta política com atenção para entender como lidamos com suas
                informações pessoais.
            </p>

            <p>
                <strong>2. Informações que Coletamos</strong>
            </p>

            <p>Coletamos vários tipos de informações, incluindo:</p>

            <ul>
                <li>
                    <strong>a. Informações Pessoais</strong>
                    <strong></strong>Podemos coletar informações pessoais como
                    seu nome, endereço de e-mail, nome de usuário, endereço de
                    cobrança, informações de pagamento e outras informações
                    fornecidas durante o registro de conta ou transações no
                    Site. Além disso, podemos coletar documentos que você
                    forneça para serviços como participação em eventos, sorteios
                    de prêmios e verificação de consentimento dos pais para
                    menores de idade.
                </li>

                <li>
                    <strong>b. Dados de Uso</strong>
                    <strong></strong>Coletamos informações automaticamente
                    quando você usa o Site, incluindo seu endereço IP, tipo de
                    navegador, sistema operacional, horários de acesso e páginas
                    visualizadas. Esses dados nos ajudam a entender como os
                    usuários interagem com nossos serviços.
                </li>

                <li>
                    <strong>c. Cookies e Tecnologias de Rastreamento</strong>
                    <strong></strong>Podemos usar cookies, web beacons, Google
                    Tags, pixels e tecnologias de rastreamento semelhantes para
                    melhorar sua experiência no nosso Site. Você pode ajustar as
                    configurações do navegador para recusar cookies, mas isso
                    pode limitar o acesso a alguns recursos.
                </li>
            </ul>

            <p></p>

            <p>
                <strong>3. Como Usamos Suas Informações</strong>
            </p>

            <p>
                Podemos usar as informações que coletamos de você para diversos
                fins, incluindo:
            </p>

            <ul>
                <li>Para fornecer e manter nossos serviços.</li>

                <li>Para processar suas transações e gerenciar sua conta.</li>

                <li>
                    Para melhorar a funcionalidade e a experiência do usuário no
                    nosso Site.
                </li>

                <li>
                    Para fornecer informações promocionais e atualizações
                    relacionadas ao jogo.
                </li>

                <li>
                    Para oferecer serviços adicionais, como participação em
                    eventos, sorteios de prêmios e verificação de consentimento
                    dos pais para menores de idade.
                </li>

                <li>Para fins de marketing e publicidade.</li>

                <li>Para cumprir obrigações legais.</li>
            </ul>

            <p></p>

            <p>
                <strong>4. Divulgação de Suas Informações</strong>
            </p>

            <p>Podemos compartilhar suas informações com:</p>

            <ul>
                <li>
                    <strong>Provedores de Serviço e Desenvolvedores:</strong>{' '}
                    Podemos compartilhar suas informações com provedores de
                    serviços e desenvolvedores terceirizados para fornecer e
                    manter nossos serviços.
                </li>

                <li>
                    <strong>Obrigações Legais:</strong> Podemos divulgar suas
                    informações se exigido por lei ou para proteger nossos
                    direitos, privacidade, segurança ou propriedade.
                </li>

                <li>
                    <strong>Transferências Comerciais:</strong> Em caso de
                    fusão, aquisição ou venda de ativos, seus dados pessoais
                    podem ser transferidos como parte da transação.
                </li>
            </ul>

            <p></p>

            <p>
                <strong>5. Registro de Menores</strong>
            </p>

            <p>
                Menores de 18 anos devem obter o consentimento de seus
                responsáveis legais ao se registrarem. Se essa exigência for
                violada, a responsabilidade recai sobre o menor e seus
                responsáveis legais, e não nos responsabilizamos por qualquer
                violação.
            </p>

            <p>
                <strong>6. Segurança dos Dados</strong>
            </p>

            <p>
                Implementamos medidas de segurança apropriadas para proteger
                suas informações contra acesso ou divulgação não autorizados. No
                entanto, observe que nenhum método de transmissão pela internet
                ou armazenamento eletrônico é completamente seguro, e não
                podemos garantir segurança absoluta.
            </p>

            <p>
                <strong>7. Transferências Internacionais de Dados</strong>
            </p>

            <p>
                Suas informações podem ser processadas em países diferentes do
                seu, incluindo servidores localizados em jurisdições onde as
                leis de privacidade podem ser diferentes das do seu país. Ao
                usar nosso Site, você concorda com essas transferências de
                dados.
            </p>

            <p>
                <strong>8. Seus Direitos</strong>
            </p>

            <p>Você tem o direito de:</p>

            <ul>
                <li>
                    Acessar, atualizar ou excluir suas informações pessoais.
                </li>

                <li>
                    Retirar seu consentimento para o processamento de suas
                    informações pessoais.
                </li>

                <li>Recusar o recebimento de comunicações de marketing.</li>

                <li></li>
            </ul>

            <p>
                Para exercer esses direitos, entre em contato conosco em:
                <a href='https://plyosgames.freshdesk.com/support/tickets/new'>
                    https://plyosgames.freshdesk.com/support/tickets/new
                </a>
                .
            </p>

            <p>
                <strong>9. Privacidade das Crianças</strong>
            </p>

            <p>
                Nossos serviços não se destinam a indivíduos menores de 13 anos,
                e não coletamos intencionalmente informações pessoais de tais
                usuários. Se descobrirmos que coletamos inadvertidamente dados
                de uma criança menor de 13 anos, eliminaremos esses dados
                imediatamente.
            </p>

            <p>
                <strong>10. Alterações a Esta Política de Privacidade</strong>
            </p>

            <p>
                Podemos atualizar esta Política de Privacidade periodicamente.
                Quando o fizermos, notificaremos os usuários atualizando a “Data
                de Vigência” no topo desta política. Incentivamos você a revisar
                esta página regularmente para verificar quaisquer alterações.
            </p>

            <p>
                <strong>11. Contato</strong>
            </p>

            <p>
                Se você tiver dúvidas ou preocupações sobre esta Política de
                Privacidade, entre em contato conosco em:
                <a href='https://plyosgames.freshdesk.com/support/tickets/new'>
                    https://plyosgames.freshdesk.com/support/tickets/new
                </a>
                .
            </p>
        </div>
    );
};

export default PrivacyPolicy;
